import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ces-floating-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-floating-bar.component.html',
})
export class CesFloatingBarComponent {}
